import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useTheme } from 'emotion-theming';

import Text from '../../../../shared/_TBComponents/Text';

const FormGroup = styled('div')`
  margin-bottom: 5px;
  z-index: 1;

  label {
    width: 100%;
  }
`;

const ErrorAndName = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 5px;
  width: 100%;
`;

const FieldError = styled('div')`
  color: #ff6600;
  font-size: 12px;
`;

// Always mounted across every step so the typed value is never lost.
// Disabled once an account is matched - "Not you?" is the deliberate way
// back to editing it.
const IdntyEmailStep = ({ disabled, error, touched }) => {
  const theme = useTheme();

  return (
    <FormGroup>
      <label htmlFor='email-field'>
        <ErrorAndName>
          <Text
            styledTextProps={{ fontSize: theme.textFontSizes[0] }}
          >
            Email Address
          </Text>
          {error && touched && <FieldError className='text-center'>{error}</FieldError>}
        </ErrorAndName>
        <Field
          className='form-control'
          disabled={disabled}
          id='email-field'
          maxLength={100}
          name='emailAddress'
          placeholder='Email'
          type='email'
        />
      </label>
    </FormGroup>
  );
};

IdntyEmailStep.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.string,
  touched: PropTypes.bool,
};

IdntyEmailStep.defaultProps = {
  disabled: false,
  error: '',
  touched: false,
};

export default IdntyEmailStep;
